<div class="card">
    <form class="g-3" name="EmployeeConfirmationPoliciesForm" (ngSubmit)="Validate(EmployeeConfirmationPoliciesForm)"
        #EmployeeConfirmationPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Employee Confirmation Policy
                </div>
                <div class="card-body">
                    <div class="ms-5">
                        <div class="row mb-3">
                            <div class="col-md-2 align-self-center">
                                <label for="RuleName" class="form-label text-label-dark">Policy Name :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                    id="RuleName" name="RuleName" [(ngModel)]="EmployeeConfirmation.RuleName"
                                    #RuleName="ngModel" maxlength="100" required>
                                <div class="invalid-feedback">
                                    Please Enter Policy Name!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2">
                                <label for="PolicyBasedOnMonthOrDays" class="form-label text-label-dark">Based
                                    On:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value='Months'
                                            name="PolicyBasedOnMonthOrDays"
                                            [(ngModel)]="EmployeeConfirmation.PolicyBasedOnMonthOrDays"
                                            [ngModelOptions]="{standalone: true}" required>
                                        Months
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" value='Days'
                                            name="PolicyBasedOnMonthOrDays"
                                            [(ngModel)]="EmployeeConfirmation.PolicyBasedOnMonthOrDays"
                                            [ngModelOptions]="{standalone: true}" required>
                                        Days
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2 align-self-center">
                                <label for="ProbationPeriod" class="form-label text-label-dark">Probation Period
                                    :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. 5"
                                    id="ProbationPeriod" name="ProbationPeriod"
                                    [(ngModel)]="EmployeeConfirmation.ProbationPeriod" #ProbationPeriod="ngModel"
                                    maxlength="3" pattern="^[0-9]*$"
                                    (keypress)="common.NumberOnly($event,false)"
                                    (keyup)="common.NumberOnly($event,false)">
                                <div class="invalid-feedback">
                                    Please Enter Probation Period!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2 align-self-center">
                                <label for="ProbationExtensionPeriod" class="form-label text-label-dark">Probation
                                    Extension Period
                                    :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. 5"
                                    id="ProbationExtensionPeriod" name="ProbationExtensionPeriod"
                                    [(ngModel)]="EmployeeConfirmation.ProbationExtensionPeriod"
                                    #ProbationExtensionPeriod="ngModel" maxlength="3" pattern="^[0-9]*$"
                                    (keypress)="common.NumberOnly($event,false)"
                                    (keyup)="common.NumberOnly($event,false)">
                                <div class="invalid-feedback">
                                    Please Enter Probation Extension Period!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2 align-self-center">
                                <label for="NoOfTimesExtensionAllowed" class="form-label text-label-dark">NoOf Times
                                    Extension Allowed
                                    :</label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. 5"
                                    id="NoOfTimesExtensionAllowed" name="NoOfTimesExtensionAllowed"
                                    [(ngModel)]="EmployeeConfirmation.NoOfTimesExtensionAllowed"
                                    #NoOfTimesExtensionAllowed="ngModel" maxlength="3" pattern="^[0-9]*$"
                                    (keypress)="common.NumberOnly($event,false)"
                                    (keyup)="common.NumberOnly($event,false)">
                                <div class="invalid-feedback">
                                    Please Enter No Of Times Extension Allowed!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2">
                                <label for="EmpType" class="form-label text-label-dark">Employee Type:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.EmployeeConfirmation.ESS_ConfirmationRuleID == 0) || (this.EmployeeConfirmation.ESS_ConfirmationRuleID > 0 && common.ToLowerCase(EmployeeConfirmation.EmpType) == 'front')">
                                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                            [(ngModel)]="EmployeeConfirmation.EmpType"
                                            [ngModelOptions]="{standalone: true}" (change)="GetApplicability()"
                                            [disabled]="EmployeeConfirmation.ESS_ConfirmationRuleID > 0" required>
                                        Front Office
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.EmployeeConfirmation.ESS_ConfirmationRuleID == 0) || (this.EmployeeConfirmation.ESS_ConfirmationRuleID > 0 && common.ToLowerCase(EmployeeConfirmation.EmpType) == 'back')">
                                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                            [(ngModel)]="EmployeeConfirmation.EmpType"
                                            [ngModelOptions]="{standalone: true}" (change)="GetApplicability()"
                                            [disabled]="EmployeeConfirmation.ESS_ConfirmationRuleID > 0" required>
                                        Back Office
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-auto">
                                <label for="IsManualAllowDate" class="form-label text-label-dark">Is Manual Allow Date :</label>
                            </div>
                            <div class="col-md-5">
                                <input class="form-check-input" style="height: 16px; width: 16px;" name="IsManualAllowDate" type="checkbox"
                                    value="" [(ngModel)]="EmployeeConfirmation.IsManualAllowDate" /> 
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2">
                                <label for="AllowConfirmationBeforeDueDate" class="form-label text-label-dark">Allow Confirmation Before Due Date :</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="AllowConfirmationBeforeDueDate"
                                            [(ngModel)]="EmployeeConfirmation.AllowConfirmationBeforeDueDate"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="AllowConfirmationBeforeDueDate"
                                            [(ngModel)]="EmployeeConfirmation.AllowConfirmationBeforeDueDate"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Default Rule :</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                            [(ngModel)]="EmployeeConfirmation.DefaultRule"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                            [(ngModel)]="EmployeeConfirmation.DefaultRule"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="EmployeeConfirmation.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && EmployeeConfirmation.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.EmployeeConfirmation.ESS_ConfirmationRuleID == 0) || (this.common.PageRight.IsEdit && this.EmployeeConfirmation.ESS_ConfirmationRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>